import { BtnDesc } from 'components/form'
import { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useAccount } from 'state/Account'
import { platform, useBoolState, useLocalStorage } from 'utils'
import { FixedWarning } from './FixedWarning'
import Tip from '../Tip'

export default function AppSuggestion() {
	const { t }   = useTranslation()
	const account = useAccount()
	const icon    = ['fab', platform.isIOS()? 'app-store-ios' : 'google-play']
	const closed  = useLocalStorage('appBannerClosed', false)
	const show    = useBoolState()

	//this needs to be inside the effect because, upon login, the account details load after the banner rendering
	useEffect(() => {
		show.toggle(account.app_url && platform.isWeb() && !closed.val)
	}, [account.app_url, closed.val]) // eslint-disable-line react-hooks/exhaustive-deps

	// noinspection JSUnresolvedReference
	/** Checks if we're in a web-app shell */
	const standaloneMode = window.navigator.standalone //iOS only
		|| window.matchMedia('(display-mode: standalone)').matches //Chrome-only
		|| document.referrer.includes('android-app://')

	function onClose() {
		closed.set(true)
	}

	const text = standaloneMode?
		<>
			{t('Need push notifications or printing to Star Micronics printers?')}{' '}
			<Trans><a href={account.app_url} target="_blank" rel="noreferrer">Try the app</a>!</Trans>
		</> : <>
			<Trans>We also have an app! <a href={account.app_url} target="_blank" rel="noreferrer">Check it here</a>.</Trans><br/>
			<small><Trans>(Or just save a web shortcut, instead <ShortcutTip/>)</Trans></small>
		</>

	return <FixedWarning variant="info" long dismissible show={show.is} icon={icon}
	                     onClose={onClose} action={account.app_url} actionExternal
	                     btnTxt={t('Download', { context: 'to ~download~ a file' })} btnHideSm children={text}
	/>
}

function ShortcutTip() {
	const { t } = useTranslation()
	return <Tip.Bubble sm>
		<p>{t('Note that the web version doesn\'t have push notification support, nor is able to send orders to Star Micronics printers.')}</p>
		<p>
			{t('To save your current webpage as a shortcut in your home screen, simply', { context: '…open the menu and…' })}{' '}
			{platform.isIOS()?
				<Trans>press <BtnDesc icon="sign-out" rotation={270} noText/> "Share" and select "Add to Home Screen".</Trans> :
				<Trans>open the top-right menu <BtnDesc icon="ellipsis-v" noText/> and select "Add to Home Screen".</Trans>
			}
		</p>
	</Tip.Bubble>
}
